// projectInputs.js — category_id controls visibility
// PROJECT_TYPE_SHOW = false → type நேரடியாக skip, category select பண்ணு
// PROJECT_TYPE_SHOW = true → type select → category show
// range: true => from/to இரண்டு input box காட்டும்

const projectInputs = {

  // ── Information Block ─────────────────────────────────────
  project_name: {
    id: 1, field: "project_name", label: "Project Name",
    type: "text", placeholder: "Enter project name",
    is_show: true, block_key: "information",
    type_id: [],
    category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },

  bhk: {
    id: 5, field: "bhk", label: "BHK",
    type: "number", placeholder: "BHK",
    is_show: true, block_key: "information",
    type_id: [], category_id: [44,22],
    category_required: [44,22],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
    range: true,
    range_from_field: "bhk_from",
    range_to_field: "bhk_to",
    range_from_placeholder: "From (1 BHK)",
    range_to_placeholder: "To (4 BHK)",
  },

  gated_community: {
    id: 9, field: "gated_community", label: "Gated Community",
    type: "select", placeholder: "Select",
    is_show: true, block_key: "information",
    type_id: [], category_id: [44],
    category_required: [44],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 2,
  },

  total_floors: {
    id: 8, field: "total_floors", label: "Total Floors",
    type: "select", placeholder: "Select total floors",
    is_show: true, block_key: "information",
    type_id: [], category_id: [22],
    category_required: [22],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 7,
  },

  property_availability: {
    id: 13, field: "property_availability", label: "Availability Status",
    type: "select", placeholder: "Select status",
    is_show: true, block_key: "information",
    type_id: [], category_id: [22,44],
    category_required: [22,44],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 8,
  },

  furnishing: {
    id: 11, field: "furnishing", label: "Furnishing Status",
    type: "select", placeholder: "Select status",
    is_show: true, block_key: "information",
    type_id: [], category_id: [22,44],
    category_required: [22,44],
    other_show: [], other_required: [],
    landtype: false, dropdown: true, dropdown_id: 3,
  },

  total_units: {
    id: 4, field: "total_units", label: "Total Units",
    type: "number", placeholder: "Enter total units",
    is_show: true, block_key: "information",
    type_id: [], category_id: [22,44],
    category_required: [22,44],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },

  rera_number: {
    id: 3, field: "rera_number", label: "RERA Id",
    type: "text", placeholder: "Enter RERA number",
    is_show: true, block_key: "information",
    type_id: [], category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },

  dtcp_number: {
    id: 34, field: "dtcp_number", label: "DTCP Id",
    type: "text", placeholder: "Enter DTCP number",
    is_show: true, block_key: "information",
    type_id: [], category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },

  description: {
    id: 35, field: "description", label: "Description",
    type: "textarea", placeholder: "Enter project description",
    is_show: true, block_key: "information",
    type_id: [], category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },

  // ── Land Area Block ────────────────────────────────────────

  // ✅ Price — range: true => from/to input boxes
  price: {
    id: 2, field: "price", label: "Price (₹)",
    type: "number", placeholder: "Enter total price",
    is_show: true, block_key: "land_area",
    type_id: [], category_id: [44,45,22],
    category_required: [44,45,22],
    other_show: [], other_required: [],
    landtype: false, dropdown: false, is_price_field: true,
    range: true,
    range_from_field: "price_from",
    range_to_field: "price_to",
    range_from_placeholder: "From Price (₹)",
    range_to_placeholder: "To Price (₹)",
  },

  // ✅ Buildup Area — sq ft மட்டும் (landtype_ids: [1])
  // range: true => 1100 sqft — 4560 sqft போன்று from/to
  buildup_area: {
    id: 40, field: "buildup_area", label: "Buildup Area",
    type: "number", placeholder: "Buildup area",
    is_show: true, block_key: "land_area",
    type_id: [], category_id: [22,44],
    category_required: [22,44],
    other_show: [], other_required: [],
    landtype: true, is_land_primary: false, dropdown: false,
    landtype_ids: [1,2,3],
    range: true,
    range_from_field: "buildup_area_from",
    range_to_field:   "buildup_area_to",
    range_from_placeholder: "Min (e.g. 1100 sq ft)",
    range_to_placeholder:   "Max (e.g. 4560 sq ft)",
  },

  // ✅ Carpet Area — sq ft மட்டும்
  carpet_area: {
    id: 41, field: "carpet_area", label: "Carpet Area",
    type: "number", placeholder: "Carpet area",
    is_show: true, block_key: "land_area",
    type_id: [], category_id: [22,44],
    category_required: [],
    other_show: [], other_required: [],
    landtype: true, is_land_primary: false, dropdown: false,
    landtype_ids: [1,2,3,4,5,6],
    range: true,
    range_from_field: "carpet_area_from",
    range_to_field:   "carpet_area_to",
    range_from_placeholder: "Min (e.g. 1100 sq ft)",
    range_to_placeholder:   "Max (e.g. 4560 sq ft)",
  },

  // ✅ Land Area (Cent) — cent unit மட்டும் (landtype_ids: [3])
  land_area_cent: {
    id: 42, field: "land_area_cent", label: "Land Area (Cent)",
    type: "number", placeholder: "Land area in cent",
    is_show: true, block_key: "land_area",
    type_id: [], category_id: [44,45],
    category_required: [45],
    other_show: [], other_required: [],
    landtype: true, is_land_primary: false, dropdown: false,
    landtype_ids: [1,2,3,4,5,6],
    range: true,
    range_from_field: "land_area_cent_from",
    range_to_field:   "land_area_cent_to",
    range_from_placeholder: "Min Cent",
    range_to_placeholder:   "Max Cent",
  },

  // ── Images ─────────────────────────────────────────────────
  thumbnail: {
    id: 20, field: "thumbnail", label: "Thumbnail Image",
    type: "file", placeholder: "",
    is_show: true, block_key: "images",
    type_id: [], category_id: [44,45,22],
    category_required: [1,2,3,4,5,6],
    other_show: [], other_required: [],
    multi_upload: false, accept: "image/*",
    landtype: false, dropdown: false,
  },

  slider: {
    id: 21, field: "slider", label: "Slider Images",
    type: "file", placeholder: "",
    is_show: true, block_key: "images",
    type_id: [], category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    multi_upload: true, accept: "image/*",
    landtype: false, dropdown: false,
  },

  // ── Documents Block ────────────────────────────────────────
  layout_type: {
    id: 30, field: "layout_type", label: "Layout Upload Type",
    type: "radio",
    is_show: true, block_key: "documents",
    type_id: [], category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
    radio_options: [
      { label: "Images", value: "image" },
      { label: "PDF",    value: "pdf"   },
    ],
    default_value: "image",
  },

  layout: {
    id: 31, field: "layout", label: "Layout",
    type: "file", placeholder: "",
    is_show: true, block_key: "documents",
    type_id: [], category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    multi_upload: true, accept: "image/*",
    landtype: false, dropdown: false,
    doc_field: true,
    doc_role: "layout",
  },

  brochure_type: {
    id: 32, field: "brochure_type", label: "Brochure Upload Type",
    type: "radio",
    is_show: true, block_key: "documents",
    type_id: [], category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    landtype: false, dropdown: false,
    radio_options: [
      { label: "Images", value: "image" },
      { label: "PDF",    value: "pdf"   },
    ],
    default_value: "image",
  },

  brochure: {
    id: 33, field: "brochure", label: "Brochure",
    type: "file", placeholder: "",
    is_show: true, block_key: "documents",
    type_id: [], category_id: [44,45,22],
    category_required: [],
    other_show: [], other_required: [],
    multi_upload: true, accept: "image/*",
    landtype: false, dropdown: false,
    doc_field: true,
    doc_role: "brochure",
  },

  // ── SEO ────────────────────────────────────────────────────
  seo_title: {
    id: 22, field: "seo_title", label: "SEO Title",
    type: "text", placeholder: "Enter SEO title",
    is_show: true, block_key: "seo",
    type_id: [], category_id: [],
    category_required: [], other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },

  seo_description: {
    id: 23, field: "seo_description", label: "SEO Meta Description",
    type: "textarea", placeholder: "Enter SEO description",
    is_show: true, block_key: "seo",
    type_id: [], category_id: [],
    category_required: [], other_show: [], other_required: [],
    landtype: false, dropdown: false,
  },
};

export default projectInputs;